import { IsNumber, Min, IsDefined } from 'class-validator';

export class TypographySizeDto {
  @IsDefined()
  @IsNumber()
  @Min(0)
  fontSize!: number;
}
